import React from 'react';
import { DollarSign } from 'lucide-react';

const CostIndicator = ({ cost }) => {
  const tooltipText = {
    '$': 'Lower cost addition - typically straightforward to implement',
    '$$': 'Higher cost - requires more significant development effort',
    '$$$': 'Premium feature - substantial development and ongoing costs'
  };

  if (!cost) return null;

  return (
    <div className="group relative inline-block">
      <div className="px-2 py-1 rounded-full text-xs bg-gray-100 text-gray-700 flex items-center gap-1">
        Cost {cost}
      </div>
      <div className="absolute z-10 invisible group-hover:visible bg-gray-900 text-white text-sm rounded p-2 mt-1 min-w-[200px] shadow-lg">
        {tooltipText[cost]}
      </div>
    </div>
  );
};

export default CostIndicator;